<template>
  <Modal :title="t('organization.edit.tabs.departments.edit.title')">
    <ModalCloseButton :to="{ name: 'OrganizationsEdit' }" />
    <Loader v-if="!department" />
    <div v-else class="form">
      <DepartmentForm
        :department="department"
        :is-saving="isSaving"
        @submit="handleSubmit"
      />
    </div>
  </Modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Modal from '@/components/Modal'
import ModalCloseButton from '@/components/ModalCloseButton'
import Loader from '@/components/Loader'
import DepartmentForm from '@/forms/DepartmentForm'
import router from '@/routes'

export default {
  name: 'DepartmentsEdit',
  components: { Loader, Modal, ModalCloseButton, DepartmentForm },
  data() {
    return {
      isSaving: false,
    }
  },
  computed: {
    ...mapGetters(['department']),
  },
  mounted() {
    this.collapseSidebar()
    this.fetchDepartments()
  },
  methods: {
    ...mapActions([
      'collapseSidebar',
      'saveDepartment',
      'fetchDepartments',
      'showFlashMessage',
    ]),

    handleSubmit({ department }) {
      this.isSaving = true
      this.saveDepartment(department)
        .then(() => {
          this.isSaving = false
          router.push({ name: 'OrganizationsEdit' })
          this.showFlashMessage({
            message:
              this.t('flash_messages.department') +
              this.t('flash_messages.update.success'),
          })
        })
        .catch(() => {
          this.isSaving = false
          this.showFlashMessage({
            message:
              this.t('flash_messages.department') +
              this.t('flash_messages.update.error'),
          })
        })
    },
  },
}
</script>
